export type EmailPreviewEndpoint =
  | "review"
  | "payment-link"
  | "payment-success"
  | "bulk-info";

export interface EmailPreviewParams {
  booking_id?: number | null;
  template_id?: number | null;
  lang?: string;
}

export async function fetchAuthenticatedHtml(
  url: string,
  accessToken: string,
): Promise<string> {
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.text();
}

export async function fetchEmailPreviewHtml(
  endpoint: EmailPreviewEndpoint,
  params: EmailPreviewParams,
  apiHost: string,
  accessToken: string,
): Promise<string> {
  const searchParams = new URLSearchParams();
  if (params.booking_id)
    searchParams.set("booking_id", String(params.booking_id));
  if (params.template_id)
    searchParams.set("template_id", String(params.template_id));
  if (params.lang) searchParams.set("lang", params.lang);

  const url = `${apiHost}/email-preview/${endpoint}${searchParams.toString() ? `?${searchParams}` : ""}`;
  return fetchAuthenticatedHtml(url, accessToken);
}
